import { getCustomerPersons } from "../api/generated/wrappers/customer";
import { createQueryKeys } from "./create-query-keys";
const customerPersonQueryKeys = createQueryKeys("customerPerson", {
    byCompany: (companyId) => ({
        queryKey: ["byCompany", companyId],
        queryFn: async () => await getCustomerPersons(companyId),
    }),
});
export default customerPersonQueryKeys;
